import { render, staticRenderFns } from "./c_merchantName.vue?vue&type=template&id=4bedff8b&scoped=true"
import script from "./c_merchantName.vue?vue&type=script&lang=js"
export * from "./c_merchantName.vue?vue&type=script&lang=js"
import style0 from "./c_merchantName.vue?vue&type=style&index=0&id=4bedff8b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bedff8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bedff8b')) {
      api.createRecord('4bedff8b', component.options)
    } else {
      api.reload('4bedff8b', component.options)
    }
    module.hot.accept("./c_merchantName.vue?vue&type=template&id=4bedff8b&scoped=true", function () {
      api.rerender('4bedff8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_merchantName.vue"
export default component.exports